import React from 'react';
import { node } from 'prop-types';
import WidgetPortal from '../WidgetPortal/WidgetPortal';

export default function ListingPortal(props) {
    return (
        <WidgetPortal elementId="fragment-listing" eraseContent {...props}>
            {props.children}
        </WidgetPortal>
    );
}

ListingPortal.propTypes = {
    children: node.isRequired,
};
